<script setup>

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
  },
  description: {
    type: String,
  }
})

defineEmits(['update:modelValue'])
</script>

<template>
  <div @click="modelValue = true" class="tw-flex">
    <slot name="trigger">
      <div
          @click="modelValue = true"
          class="tw-bg-primary tw-text-white tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-py-1 tw-cursor-pointer tw-relative tw-px-3 tw-space-x-2 tw-no-underline"
      >
        <slot name="trigger-content"/>
      </div>
    </slot>
  </div>
  <teleport to="body">
    <transition
        enter-active-class="tw-ease-out tw-duration-300"
        enter-from-class="tw-opacity-0"
        enter-to-class="tw-opacity-100"
        leave-active-class="tw-ease-in tw-duration-200"
        leave-from-class="tw-opacity-100"
        leave-to-class="tw-opacity-0"
    >
      <div
          v-if="modelValue"
          class="tw-fixed tw-w-screen tw-h-screen tw-flex tw-justify-center tw-items-center tw-inset-0"
      >
        <div @click="modelValue = false" class="tw-fixed tw-inset-0" style="background: rgba(0,0,0,0.2)"></div>

        <div
            class="tw-rounded-xl tw-bg-white tw-z-10 tw-shadow-md"
        >
          <slot>
            <div class="tw-flex tw-flex-col tw-m-auto tw-rounded-xl tw-bg-white tw-min-h-xl tw-p-5 tw-gap-5">
              <h2 class="tw-text-lg lg:tw-text-2xl tw-font-bold">
                <slot name="title">{{ title ?? '' }}</slot>
              </h2>

              <div v-if="description ?? $slots.description" class="tw-font-semibold tw-flex tw-flex-col">
                <slot name="description">{{ description ?? '' }}</slot>
              </div>

              <div class="tw-flex tw-flex-col tw-gap-3 tw-text-base tw-leading-7 tw-text-gray-600">
                <slot name="content"></slot>
              </div>

              <div v-if="$slots.actions" class="tw-flex tw-gap-5 tw-items-center tw-justify-center">
                <slot name="actions" />
              </div>
            </div>

          </slot>
        </div>
      </div>
    </transition>
  </teleport>
</template>
